import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Routes from "../../config/Routes";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Loadable from "react-loading-overlay";
import CheckIcon from "material-ui/svg-icons/navigation/check";

class Body extends Component {
	confirmEmail = () => {
		if (this.props.confirmEmail) {
			return (
				<div
					className="bottom10"
					style={{
						color: "#558F6E",
						fontSize: 17,
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}
				>
					<CheckIcon color="#558F6E" />
					{
						"Bienvenido a UPSRA. Su mail se ha validado con éxito. Lo invitamos a presentar sus Declaraciones Juradas a través de nuestra plataforma."
					}
				</div>
			);
		}
	};
	render() {
		return (
			<div>
				<Breadcrumb {...this.props.location} />
				<div className="body-container" style={this.props.style}>
					<Loadable
						spinner
						active={this.props.loading}
						text={this.props.loadingText}
					>
						{this.confirmEmail()}
						<Routes />
					</Loadable>
				</div>
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		loading: state.app.loading,
		loadingText: state.app.loadingText
	};
}

export default withRouter(connect(mapStateToProps)(Body));



// WEBPACK FOOTER //
// ./src/components/Body/Body.js